import React from 'react';
import PropTypes from 'prop-types';

import { MobileThumbnail } from '../Thumbnail';
import { useDynamicMaxHeight } from '../../hooks/useDynamicMaxHeight';

const MobileThumbnailList = ({
  thumbnails,
  onThumbnailClick,
  onThumbnailDoubleClick,
  onClickUntrack,
  activeDisplaySetInstanceUIDs = [],
  viewPreset,
  ThumbnailMenuItems,
}) => {
  const { ref } = useDynamicMaxHeight(thumbnails);

  const listItems = thumbnails?.filter(
    ({ componentType }) =>
      componentType === 'thumbnailNoImage' || viewPreset === 'list'
  );

  const thumbnailItems = thumbnails?.filter(
    ({ componentType }) =>
      componentType !== 'thumbnailNoImage' && viewPreset === 'thumbnails'
  );

  return (
    <div className="w-full">
      <div
        ref={ref}
        className="w-full flex overflow-x-auto overflow-y-hidden"
      >
        {/* Thumbnail Items */}
        {thumbnailItems.length > 0 && (
          <div
            id="ohif-thumbnail-thumbnails"
            className="flex flex-row flex-nowrap gap-[4px] w-full px-[5px] py-[4px]"
          >
            {thumbnailItems.map(item => {
              const {
                displaySetInstanceUID,
                componentType,
                numInstances,
                loadingProgress,
                ...rest
              } = item;

              const isActive =
                activeDisplaySetInstanceUIDs.includes(displaySetInstanceUID);

              return (
                <MobileThumbnail
                  key={displaySetInstanceUID}
                  {...rest}
                  displaySetInstanceUID={displaySetInstanceUID}
                  numInstances={numInstances || 1}
                  isActive={isActive}
                  thumbnailType={componentType}
                  viewPreset="thumbnails"
                  onClick={onThumbnailClick.bind(null, displaySetInstanceUID)}
                  onDoubleClick={onThumbnailDoubleClick.bind(null, displaySetInstanceUID)}
                  onClickUntrack={onClickUntrack.bind(null, displaySetInstanceUID)}
                  ThumbnailMenuItems={ThumbnailMenuItems}
                  loadingProgress={loadingProgress}
                />
              );
            })}
          </div>
        )}

        {/* List Items (also horizontal) */}
        {listItems.length > 0 && (
          <div
            id="ohif-thumbnail-list"
            className="flex flex-row flex-nowrap gap-[4px] w-full px-[5px] py-[4px]"
          >
            {listItems.map(item => {
              const {
                displaySetInstanceUID,
                componentType,
                numInstances,
                ...rest
              } = item;

              const isActive =
                activeDisplaySetInstanceUIDs.includes(displaySetInstanceUID);

              return (
                <MobileThumbnail
                  key={displaySetInstanceUID}
                  {...rest}
                  displaySetInstanceUID={displaySetInstanceUID}
                  numInstances={numInstances || 1}
                  isActive={isActive}
                  thumbnailType={componentType}
                  viewPreset="list"
                  onClick={onThumbnailClick.bind(null, displaySetInstanceUID)}
                  onDoubleClick={onThumbnailDoubleClick.bind(null, displaySetInstanceUID)}
                  onClickUntrack={onClickUntrack.bind(null, displaySetInstanceUID)}
                  ThumbnailMenuItems={ThumbnailMenuItems}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export { MobileThumbnailList };
